'use client';

import { Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useLocale } from 'next-intl';

export interface HelpLinkProps {
  /** The anchor hash for the help section (e.g., "bot-settings") */
  section: string;
  /** Tooltip text shown on hover */
  tooltip: string;
}

export function HelpLink({ section, tooltip }: HelpLinkProps) {
  const locale = useLocale();

  return (
    <Tooltip title={tooltip} arrow>
      <IconButton
        component="a"
        href={`/${locale}/help#${section}`}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        sx={{
          ml: 0.5,
          opacity: 0.5,
          '&:hover': { opacity: 1 },
        }}
      >
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
